module.exports = __webpack_public_path__ + "img/interest-cost-icon.1240349b.svg";